import axios from 'axios'
import Vue from 'vue'

export function uploadBlob(blob, filename, onProgress=null, cancelTokenSource=null){
  const emp=()=>{};
  const directUpload = process.env.VUE_APP_DIRECT_UPLOAD;
  if(directUpload){
    return startDirectUpload(blob,filename,onProgress || emp, cancelTokenSource);
  }else{
    return startS3Upload(blob,filename,onProgress || emp, cancelTokenSource);
  }
}

function startDirectUpload(blob, filename, onProgress, cancelTokenSource){
  const data = new FormData();
  data.append('file', blob);
  data.append('filename', filename);

  return Vue.prototype.$http.post('/person/upload',data,{
    headers:{
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: onProgress,
    cancelToken: cancelTokenSource ? cancelTokenSource.token : null
  }).then((response)=>{
    return {
      url:response.data.url,
      key:response.data.key
    };
  });
}

function startS3Upload(blob, filename, onProgress, cancelTokenSource){
  return Vue.prototype.$http.post('/person/upload',{filename:filename}).then((response)=>{
    const post_url=response.data.post_url;
    const url=response.data.url;
    const formData=response.data.data;
    return uploadToS3(blob, filename,post_url,formData,url, onProgress, cancelTokenSource);
  });
}

function uploadToS3(blob, filename, postUrl, data, url, onProgress, cancelTokenSource){
  const ax=axios.create();
  let formData = new FormData();
  for(let key in data){
    if(data.hasOwnProperty(key)){
      formData.append(key,data[key]);
    }
  }
  formData.append('file', blob, filename);
  return ax.post(postUrl,formData,{
    headers:{
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: onProgress,
    cancelToken: cancelTokenSource ? cancelTokenSource.token : null
  }).then(()=>{
    return {
      url,key:data.key
    };
  });

}
